<script setup lang="ts">
import { defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import AlertPopup from './AlertPopup.vue';
import { useAppStore } from '../../store/appStore';

const props = defineProps<{
  shortLink: string;
}>();

const appStore = useAppStore();
const router = useRouter();

const { showDeleteWorkspacePopup, baseWorkspaceShortLink } = storeToRefs(appStore);

async function deleteWorkspace() {
  appStore.closeDeleteWorkspacePopup();
  await appStore.deleteWorkspace(props.shortLink);
  await appStore.loadWorkspaces();

  await router.push({
    name: 'workspace',
    params: {
      short_link: baseWorkspaceShortLink.value,
    },
  });
}

function cancelDeleteWorkspace() {
  appStore.closeDeleteWorkspacePopup();
}
</script>

<template>
  <AlertPopup
    :title="'Are you sure?'"
    :subtitle="'This will also delete all associated directories.'"
    :cancel="cancelDeleteWorkspace"
    :ok="deleteWorkspace"
    :show="showDeleteWorkspacePopup"
  />
</template>
